const initialState = {
    content: {},
};
const shop = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_SHOP_DETAILS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default shop;
